export function getCharacterImageUrl(imageName) {
    return `assets/characters/${imageName}.png`;
}

export function getItemImageUrl(imageName) {
    return `assets/items/${imageName}.png`;
}